<template>
    <div class="flex flex-wrap -mx-4">
        <div class="flex justify-center m-3 w-full" v-if="!list.length">
            <spinner />
        </div>
        <productBlock
            v-for="(p, pi) in list"
            :key="pi"
            :product="p"
            :productWidthClass="productWidthClass"
        />
    </div>
</template>

<script>
import spinner from '@/components/spinner.vue';
import productBlock from '@/components/productBlock.vue';

export default {
    components: { spinner, productBlock },
    props: {
        list: { type: Array, default: () => [] },
        productWidthClass: {
            default: 'w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/5 xl:w-1/6 '
        }
    }
};
</script>
